import { render, staticRenderFns } from "./DashboadCard.vue?vue&type=template&id=e73e65f0&scoped=true&"
import script from "./DashboadCard.vue?vue&type=script&lang=js&"
export * from "./DashboadCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboadCard.vue?vue&type=style&index=0&id=e73e65f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73e65f0",
  null
  
)

export default component.exports